export enum ShopperAgentShortfallKind {
  Handoff = "handoff",
  DetectedHandoff = "detected_handoff",
  DirectToSupport = "direct_to_support",
}
